import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteCategoryApi, deletePackageApi, getCategoriesApi, getPackageSizeApi, getSubCategoriesApi, IMG_URL } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setSelectedCategory, setSelectedPackage, setSelectedSubCategory } from '../../redux/authModalSlice';

const SubCategoryTableV2 = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [subCategoryLoading,setSubCategoryLoading] = useState(false)
    const dispatch = useDispatch()


    const [itemsPerPage] = useState(12);


    const { user } = useSelector((state) => state.authModal);
    const [categories, setCategories] = useState();


    const fromCountry = user?.from;
    const toCountry = user?.to;




    // console.log("UserData:", fromCountry)

    const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     const table = $('#dataTable').DataTable({
    //         pageLength: 10,
    //     });
    //     return () => {
    //         table.destroy(true);
    //     };
    // }, []);


    const getCategoriesData = async () => {


        setLoading(true);

        setSubCategoryLoading(true);

        // const toastId = toast.loading("Fetching Categories...");

        try {
            const data = await getSubCategoriesApi();
            setCategories(data || []);
            setSubCategoryLoading(false)
            // toast.success("Categories fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching categories.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
            setSubCategoryLoading(false);

        }
    };
    useEffect(() => {

        getCategoriesData()


    }, [])



    // const [categories, setCategories] = useState([
    //     {
    //         id: 1,
    //         name: "Electronics",
    //         isPublished: true,
    //     },
    //     {
    //         id: 2,
    //         name: "Clothing",
    //         isPublished: false,
    //     },
    //     {
    //         id: 3,
    //         name: "Books",
    //         isPublished: true,
    //     },
    //     {
    //         id: 4,
    //         name: "Home & Kitchen",
    //         isPublished: true,
    //     },
    // ]);




    const [searchQuery, setSearchQuery] = useState("");


    const filteredData = categories?.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );




    const totalItems = filteredData?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const currentItems = filteredData?.slice(startIdx, startIdx + itemsPerPage);
    // const currentItems = []

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleConfirmDelete = async () => {
        if (!selectedCategoryId) return;

        setLoading(true);



        const toastId = toast.loading("Deleting...");

        try {
            const data = await deleteCategoryApi(selectedCategoryId, { isActive: "DELETE", isSubCategory: true, from: fromCountry, to: toCountry });
            getCategoriesData()

            toast.success("Deletd", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong while fetching categories.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
            // setSelectedCategoryId(null)
        }

    }
    return (
      <>
        <div className="card h-100 p-0 radius-12">
          <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <form className="navbar-search">
                <input
                  type="text"
                  className="bg-base h-40-px w-auto"
                  name="search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Icon icon="ion:search-outline" className="icon" />
              </form>
            </div>
            <Link
              to={"/add-sub-category"}
              className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Add New Sub Category
            </Link>
          </div>
          <div
            className="card-body p-24"
            style={{
              minHeight: "60vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="row gy-4" style={{ flex: "1" }}>
              {subCategoryLoading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="spinner-border"
                    role="status"
                    style={{
                      color: "#243E85",
                      width: "2rem",
                      height: "2rem",
                      borderWidth: "0.3em",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : currentItems?.length > 0 ? (
                currentItems?.map((category) => (
                  <div
                    className="col-xxl-2 col-md-6 col-sm-6 col-12 user-grid-card   "
                    key={category?.id}
                  >
                    <div
                      className="position-relative  radius-12 overflow-hidden"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "1px solid #243E85",
                        background: "#E8EEFF",
                      }}
                    >
                      <span
                        style={{ left: "4px", background: "#243E85" }}
                        className={`${
                          category?.isActive
                            ? "bg-success-focus text-success-main"
                            : "bg-danger-focus text-danger-main"
                        } px-16 py-4 rounded-pill fw-medium text-sm position-absolute top-0  me-16 mt-16`}
                      >
                        {category?.isActive ? "Published" : "Not Published"}
                      </span>

                      <div className="dropdown position-absolute top-0 end-0 me-16 mt-16">
                        <button
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          className="bg-white-gradient-light text-primary-600 w-32-px h-32-px radius-8 border border-primary-light-white d-flex justify-content-center align-items-center text-white"
                        >
                          <Icon
                            icon="entypo:dots-three-vertical"
                            className="icon "
                          />
                        </button>
                        <ul className="dropdown-menu p-12 border bg-base shadow">
                          <li>
                            <Link
                              onClick={() =>
                                dispatch(setSelectedSubCategory(category))
                              }
                              className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 d-flex align-items-center gap-10"
                              to={"/add-sub-category"}
                            >
                              Edit
                            </Link>
                          </li>
                          <li>
                            <button
                              onClick={() => setSelectedCategoryId(category.id)}
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalEdit"
                              type="button"
                              className="delete-btn dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-danger-100 text-hover-danger-600 d-flex align-items-center gap-10"
                            >
                              Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div
                        className="ps-16 pb-16 pe-16 text-center pt-16"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <div style={{ marginTop: "40px" }}>
                          <div
                            className=" w-120-px h-120-px object-fit-cover"
                            style={{ margin: "auto" }}
                          >
                            <img
                              // src="assets/images/user-grid/package.jpg"
                              src={`${IMG_URL}/${category?.image_url}`}
                              alt=""
                              className="p-4 w-90 h-100"
                              style={{ objectFit: "contain" }}
                            />
                          </div>

                          <h6
                            className="text-lg mt-16 fw-semibold"
                            style={{
                              background:
                                "linear-gradient(to right, #243E85, #779BFF)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              display: "inline-block",
                            }}
                          >
                            {category?.name}
                          </h6>

                          <div
                            className="btn text-primary-600 gap-2 bg-primary-light border border-primary-light-white px-18 py-8 d-flex align-items-center justify-content-center "
                            style={{ flexDirection: "column" }}
                          >
                            {" "}
                            <span style={{ fontWeight: "semibold" }}>
                              Parent Category :{" "}
                            </span>{" "}
                            <span style={{ fontWeight: "semibold" }}>
                              {" "}
                              {category.parent_category.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    minHeight: "60vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p>No Sub Category Found</p>
                </div>
              )}
            </div>
            {/* <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                    <span>Showing 1 to 10 of 12 entries</span>
                    <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
                                to="#"
                            >
                                <Icon icon="ep:d-arrow-left" className="" />
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md bg-primary-600 text-white"
                                to="#"
                            >
                                1
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px"
                                to="#"
                            >
                                2
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                                to="#"
                            >
                                3
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                                to="#"
                            >
                                4
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                                to="#"
                            >
                                5
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                to="#"
                            >
                                {" "}
                                <Icon icon="ep:d-arrow-right" className="" />{" "}
                            </Link>
                        </li>
                    </ul>
                </div> */}

            {filteredData?.length > itemsPerPage && (
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                  {filteredData?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${
                          currentPage === index + 1
                            ? "bg-primary-600 text-white"
                            : "bg-primary-50 text-secondary-light"
                        } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        <div
          className="modal fade"
          id="exampleModalEdit"
          tabIndex={-1}
          aria-labelledby="exampleModalEditLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                  Confirm Deletion
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-24 text-center">
                <p className="mb-4 fs-6 text-secondary">
                  Are you sure you want to delete this item?
                </p>
                <div className="d-flex justify-content-center gap-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default SubCategoryTableV2;